import React from "react";
import JotformEmbed from "react-jotform-embed";

import { SanityJotFormBlock } from "@graphql-types";
import { StandardLayoutContainer } from "@util/standard";

interface Props {
  data: SanityJotFormBlock;
}

function JotFormBlock({ data }: Props) {
  if (data == null || data.jotFormId == null) return null;
  const formEmbedUrl = `https://form.jotform.com/${data.jotFormId}`;

  return (
    <StandardLayoutContainer margin="auto" flexDirection="column">
      {data.blockHeader && <h2>{data.blockHeader}</h2>}
      <JotformEmbed src={formEmbedUrl} />
    </StandardLayoutContainer>
  );
}

export default JotFormBlock;
